import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../redux/actions';
import styles from './style.js';
import './style.css';
// import Button from '../ui/Button';
// import { Link } from 'react-router-dom';
import MUTypography from '../ui/MUTypography';
import BasicPageComponent from '../BasicPageComponent';
import FeaturedAPIs from '../FeaturedAPIs';
import Improvements from '../Improvements';
import Header from '../Header';

class Home extends Component {

  render() {
    const { classes } = this.props;

    return (
      <div >

        <section id="slider" className="slider-element force-full-screen full-screen">
          <div className="force-full-screen full-screen dark bg">

            <div className="homepage">
              <Header srcImage={require('../../images/emlak-katilim-developer-logo.png')} homepage={true} />
            </div>

            <div className={classes.intro}>
              <p style={{ fontSize: '30px' }}>
                Let's Build Digital
              </p>

              <MUTypography paragraph={true} className={classes.typography}>
                Under The Same Roof
              </MUTypography>
            </div>

            {/* <div>
              <Button
                variant='text'
                classes={{ root: classes.btnRegister, text: classes.txtRegister, label: classes.lblRegister }}
                text="REGISTER "
                component={Link}
                to="/register"
              />
            </div> */}

          </div>

          <div style={{
            position: 'relative',
            zIndex: '4',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: '#F2F4F7',
            marginBottom: '-5%'
          }}>
            {/* <a className ={classes.section4} href='#feature'>
              <img src = {require('../../images/scrollButton.png')} />
            </a> */}
          </div>

          <div id='feature' className="force-full-screen full-screen dark"
          >
            <BasicPageComponent
              type="1"
              title='Discover API’s'
              description='Discover the wide range of Emlak Katılım APIs ranging from accounts to payments, from investment products to cards!'
              children={<FeaturedAPIs />}
            />
            <BasicPageComponent
              type="2"
              title='Improvements'
              description='Here You Can Get Latest Updates About Emlak Katilim Api Store'
              children={<Improvements />}
            />
          </div>
        </section>
      </div>
    );
  }
}

Home.propTypes = {
  login: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  login: state.login
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Home);
